import React from 'react'
import styled from 'styled-components'
import classNames from 'classnames'
import { Progress as ProgressBs, ProgressProps as ProgressPropsBs } from '@bootstrap-styled/v4'
import { omit } from 'ramda'
import Color from '@bootstrap-styled/color'

//type definition
export type ProgressProps = {
    color?: ProgressPropsBs['color'] | 'active' | 'pending' | 'givens'
} & Omit<ProgressPropsBs, 'color' | 'as' | 'property'>

const Progress = styled(
    (attrs: ProgressProps): JSX.Element => (
        <ProgressBs {...omit(['color', 'pendingColor'], attrs)} />
    )
).attrs(props => ({
    className: classNames(props.className, {
        [`bg-${props.color}`]: !!props.color
    }),
    givensColor: Color(props.theme['$opal'])
        .lightness(85)
        .string()
}))`
    /* Custom colors */
    &.bg-givens {
        background-color: ${props => props.givensColor};
    }
`
export default Progress
